var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "bg-light py-4" },
    [
      _c("div", { staticClass: "row pb-3" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "router-link",
              { staticClass: "text-primary-link", attrs: { to: "/rewards" } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.rewards.title")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass: "text-primary-link",
                attrs: { to: "/user-rewards" }
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("message.rewards.my_redeemed_rewards")) +
                    "\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c("i", { staticClass: "fal fa-angle-right" }),
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("message.rewards.delivery_info")) +
                "\n    "
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm.userReward
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6 offset-lg-3" }, [
              _vm.userReward.reward.delivery_info_type === "email_tel"
                ? _c("div", { staticClass: "card" }, [
                    _c("img", {
                      staticClass: "card-img-top",
                      attrs: {
                        src: _vm.userReward.reward.image_url,
                        alt: _vm.userReward.reward.title_th
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "card-body" }, [
                      _c(
                        "div",
                        { staticClass: "text-remark mb-2 text-center" },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t(
                                  "message.rewards.delivery_info_form_title"
                                )
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "text-center" }, [
                        _c("b", [
                          _vm._v(
                            _vm._s(
                              _vm.$i18n.locale === "th"
                                ? _vm.userReward.reward.title_th
                                : _vm.userReward.reward.title_en
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "py-2" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "contactTel" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.shipping_address.tel"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contactTel,
                                expression: "contactTel"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "form-alert": _vm.errors.has("contactTel")
                            },
                            attrs: {
                              type: "tel",
                              id: "contactTel",
                              name: "contactTel",
                              placeholder: "080-000-0000"
                            },
                            domProps: { value: _vm.contactTel },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.contactTel = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("contactTel")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("message.required_field")) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", { attrs: { for: "contactEmail" } }, [
                            _vm._v(
                              _vm._s(_vm.$t("message.shipping_address.email"))
                            )
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.contactEmail,
                                expression: "contactEmail"
                              }
                            ],
                            staticClass: "form-control",
                            class: {
                              "form-alert": _vm.errors.has("contactEmail")
                            },
                            attrs: {
                              type: "email",
                              id: "contactEmail",
                              name: "contactEmail",
                              placeholder: "name@example.com"
                            },
                            domProps: { value: _vm.contactEmail },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.contactEmail = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _vm.errors.has("contactEmail")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("message.required_field")) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info btn-block",
                          attrs: { disabled: _vm.isLoading },
                          on: {
                            click: function($event) {
                              return _vm.saveDeliveryInfo()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isLoading
                                  ? _vm.$t("message.button.loading")
                                  : _vm.$t("message.button.save")
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.userReward.reward.delivery_info_type === "full_address"
                ? _c("div", { staticClass: "card" }, [
                    _c("div", { staticClass: "card-body" }, [
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "inputName" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$i18n.t("message.shipping_address.full_name")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userShippingAddress.name,
                              expression: "userShippingAddress.name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "form-alert": _vm.errors.has("contactName")
                          },
                          attrs: {
                            type: "text",
                            id: "inputName",
                            name: "contactName",
                            placeholder: ""
                          },
                          domProps: { value: _vm.userShippingAddress.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userShippingAddress,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("contactName")
                          ? _c(
                              "div",
                              { staticClass: "mt-1 text-remark -status-alert" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("message.required_field")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "inputTel" } }, [
                          _vm._v(
                            _vm._s(_vm.$i18n.t("message.shipping_address.tel"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userShippingAddress.tel,
                              expression: "userShippingAddress.tel"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "form-alert": _vm.errors.has("contactTel") },
                          attrs: {
                            type: "tel",
                            id: "inputTel",
                            name: "contactTel",
                            placeholder: "080-000-0000"
                          },
                          domProps: { value: _vm.userShippingAddress.tel },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userShippingAddress,
                                "tel",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("contactTel")
                          ? _c(
                              "div",
                              { staticClass: "mt-1 text-remark -status-alert" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("message.required_field")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$i18n.t("message.shipping_address.address")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "div",
                            { staticClass: "form-check form-check-inline" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.userShippingAddress.building_type,
                                    expression:
                                      "userShippingAddress.building_type"
                                  }
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "radio",
                                  name: "radioBuildingType",
                                  id: "radioBuildingType1"
                                },
                                domProps: {
                                  value: 1,
                                  checked: _vm._q(
                                    _vm.userShippingAddress.building_type,
                                    1
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.userShippingAddress,
                                      "building_type",
                                      1
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "radioBuildingType1" }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$i18n.t(
                                          "message.shipping_address.type_address_home"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-check form-check-inline" },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.userShippingAddress.building_type,
                                    expression:
                                      "userShippingAddress.building_type"
                                  }
                                ],
                                staticClass: "form-check-input",
                                attrs: {
                                  type: "radio",
                                  name: "radioBuildingType",
                                  id: "radioBuildingType2"
                                },
                                domProps: {
                                  value: 2,
                                  checked: _vm._q(
                                    _vm.userShippingAddress.building_type,
                                    2
                                  )
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.$set(
                                      _vm.userShippingAddress,
                                      "building_type",
                                      2
                                    )
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "form-check-label",
                                  attrs: { for: "radioBuildingType2" }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$i18n.t(
                                          "message.shipping_address.type_address_condo"
                                        )
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _vm.isCondo()
                        ? _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "inputVillage" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$i18n.t(
                                    "message.shipping_address.village"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userShippingAddress.village,
                                  expression: "userShippingAddress.village"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              key: "inputVillage",
                              staticClass: "form-control",
                              class: {
                                "form-alert": _vm.errors.has("inputVillage")
                              },
                              attrs: {
                                type: "text",
                                id: "inputVillage",
                                name: "inputVillage"
                              },
                              domProps: {
                                value: _vm.userShippingAddress.village
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.userShippingAddress,
                                    "village",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.has("inputVillage")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-1 text-remark -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("message.required_field")
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isCondo()
                        ? _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "inputRoomNo" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$i18n.t(
                                    "message.shipping_address.room_no"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userShippingAddress.room_no,
                                  expression: "userShippingAddress.room_no"
                                }
                              ],
                              staticClass: "form-control",
                              attrs: { type: "text", id: "inputRoomNo" },
                              domProps: {
                                value: _vm.userShippingAddress.room_no
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.userShippingAddress,
                                    "room_no",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "inputHouseNo" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$i18n.t("message.shipping_address.house_no")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userShippingAddress.house_no,
                              expression: "userShippingAddress.house_no"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          key: "inputHouseNo",
                          staticClass: "form-control",
                          class: {
                            "form-alert": _vm.errors.has("inputHouseNo")
                          },
                          attrs: {
                            type: "text",
                            id: "inputHouseNo",
                            name: "inputHouseNo"
                          },
                          domProps: { value: _vm.userShippingAddress.house_no },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userShippingAddress,
                                "house_no",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("inputHouseNo")
                          ? _c(
                              "div",
                              { staticClass: "mt-1 text-remark -status-alert" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("message.required_field")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      !_vm.isCondo()
                        ? _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "inputVillageNo" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$i18n.t(
                                    "message.shipping_address.village_no"
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "text-danger" }, [
                              _vm._v("*")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userShippingAddress.village_no,
                                  expression: "userShippingAddress.village_no"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              key: "inputVillageNo",
                              staticClass: "form-control",
                              class: {
                                "form-alert": _vm.errors.has("inputVillageNo")
                              },
                              attrs: {
                                type: "text",
                                id: "inputVillageNo",
                                name: "inputVillageNo"
                              },
                              domProps: {
                                value: _vm.userShippingAddress.village_no
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.userShippingAddress,
                                    "village_no",
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.errors.has("inputVillageNo")
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "mt-1 text-remark -status-alert"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.$t("message.required_field")
                                        ) +
                                        "\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "inputSoi" } }, [
                          _vm._v(
                            _vm._s(_vm.$i18n.t("message.shipping_address.soi"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userShippingAddress.soi,
                              expression: "userShippingAddress.soi"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text", id: "inputSoi" },
                          domProps: { value: _vm.userShippingAddress.soi },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userShippingAddress,
                                "soi",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "inputRoad" } }, [
                          _vm._v(
                            _vm._s(_vm.$i18n.t("message.shipping_address.road"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.userShippingAddress.road,
                              expression: "userShippingAddress.road"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "form-alert": _vm.errors.has("inputRoad") },
                          attrs: {
                            type: "text",
                            id: "inputRoad",
                            name: "inputRoad"
                          },
                          domProps: { value: _vm.userShippingAddress.road },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.userShippingAddress,
                                "road",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("inputRoad")
                          ? _c(
                              "div",
                              { staticClass: "mt-1 text-remark -status-alert" },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(_vm.$t("message.required_field")) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          { attrs: { for: "inputAddressProvince" } },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$i18n.t("message.shipping_address.province")
                              )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.userShippingAddress.address_province_id,
                                  expression:
                                    "userShippingAddress.address_province_id"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "form-alert": _vm.errors.has(
                                  "inputAddressProvince"
                                )
                              },
                              attrs: {
                                id: "inputAddressProvince",
                                name: "inputAddressProvince"
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.userShippingAddress,
                                      "address_province_id",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.changeAddressProvince(
                                      _vm.userShippingAddress
                                        .address_province_id
                                    )
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$i18n.t(
                                      "message.booking.contact_step.set_province"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.sortedProvinces, function(
                                addressProvince
                              ) {
                                return _c(
                                  "option",
                                  { domProps: { value: addressProvince.id } },
                                  [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          _vm._f("multiLangName")(
                                            addressProvince
                                          )
                                        ) +
                                        "\n                  "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.errors.has("inputAddressProvince")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(
                                        _vm.$t("message.required_selection")
                                      ) +
                                      "\n                "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "inputDistrict" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$i18n.t("message.shipping_address.district")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.userShippingAddress.district_id,
                                  expression: "userShippingAddress.district_id"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "form-alert": _vm.errors.has("inputDistrict")
                              },
                              attrs: {
                                id: "inputDistrict",
                                name: "inputDistrict"
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$selectedVal = Array.prototype.filter
                                      .call($event.target.options, function(o) {
                                        return o.selected
                                      })
                                      .map(function(o) {
                                        var val =
                                          "_value" in o ? o._value : o.value
                                        return val
                                      })
                                    _vm.$set(
                                      _vm.userShippingAddress,
                                      "district_id",
                                      $event.target.multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    )
                                  },
                                  function($event) {
                                    return _vm.changeDistrict(
                                      _vm.userShippingAddress.district_id
                                    )
                                  }
                                ]
                              }
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$i18n.t(
                                      "message.booking.contact_step.set_district"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.sortedDistricts, function(district) {
                                return _c(
                                  "option",
                                  { domProps: { value: district.id } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm._f("multiLangName")(district)
                                        ) +
                                        "\n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.errors.has("inputDistrict")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("message.required_selection")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-group" }, [
                        _c("label", { attrs: { for: "inputSubDistrict" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$i18n.t("message.shipping_address.zip_code")
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "text-danger" }, [
                          _vm._v("*")
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.userShippingAddress.sub_district_id,
                                  expression:
                                    "userShippingAddress.sub_district_id"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "form-alert": _vm.errors.has("inputSubDistrict")
                              },
                              attrs: {
                                id: "inputSubDistrict",
                                name: "inputSubDistrict"
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.userShippingAddress,
                                    "sub_district_id",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            [
                              _c("option", { domProps: { value: null } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$i18n.t(
                                      "message.booking.contact_step.set_zip_code"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.sortedSubDistricts, function(
                                subDistrcict,
                                index
                              ) {
                                return _c(
                                  "option",
                                  { domProps: { value: subDistrcict.id } },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(subDistrcict.zip_code) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("multiLangName")(subDistrcict)
                                        ) +
                                        " \n                "
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _vm.errors.has("inputSubDistrict")
                            ? _c(
                                "div",
                                {
                                  staticClass: "mt-1 text-remark -status-alert"
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("message.required_selection")
                                      ) +
                                      "\n              "
                                  )
                                ]
                              )
                            : _vm._e()
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-info btn-block",
                          attrs: { disabled: _vm.isLoading },
                          on: {
                            click: function($event) {
                              return _vm.saveDeliveryInfo()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isLoading
                                  ? _vm.$t("message.button.loading")
                                  : _vm.$t("message.button.save")
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isLoadingUserShippingAddress ? _c("loader") : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { "hide-footer": true, "hide-header": true },
          model: {
            value: _vm.showModal,
            callback: function($$v) {
              _vm.showModal = $$v
            },
            expression: "showModal"
          }
        },
        [
          _vm.userReward
            ? _c("div", { staticClass: "text-center" }, [
                _c("img", {
                  staticClass: "img-fluid rounded",
                  attrs: {
                    src: _vm.userReward.reward.image_url,
                    alt: _vm.userReward.reward.title_th
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "pt-3" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("message.rewards.contact_success01")) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "py-3" }, [
                  _c("b", [
                    _vm._v(_vm._s(_vm.$t("message.rewards.contact_success02")))
                  ])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-info btn-block",
                      on: {
                        click: function($event) {
                          return _vm.closeModal()
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("message.button.close")) +
                          "\n        "
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6071ebdc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6071ebdc","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reward/UserRewardDeliveryInfo.vue
// module id = 2320
// module chunks = 0